import { render, staticRenderFns } from "./structureDetail.vue?vue&type=template&id=797dd6bb&scoped=true"
import script from "./structureDetail.vue?vue&type=script&lang=js"
export * from "./structureDetail.vue?vue&type=script&lang=js"
import style0 from "./structureDetail.vue?vue&type=style&index=0&id=797dd6bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dd6bb",
  null
  
)

export default component.exports